
import ActionsNotes from '@/components/_ActionsNotes/index.vue';
import RiskScore from '@/components/_RiskScore/index.vue';
import AvgPayment from '@/components/_AvgPayment/index.vue';
import { attachmentDownload } from '@/api/attachment';
import gql from 'graphql-tag';
import Contacts from '@/components/_Contacts/index.vue';
import DocumentTable from '@/components/_Document/DocumentTable.vue';
import {
	PAYMENT_DOCUMENT,
	GET_CREDIT_NOTES,
	GET_DEBIT_NOTES,
	GET_INVOICES,
	GET_CONTACTS,
	REACTIVATE_ENDPOINT,
	FIND_INVOICE_PAYMENT_TRIGGER,
	GET_NEXT_ACTIONS_V2
} from '@/gql';
import { mapGetters } from 'vuex';
import { EventBus } from '@/eventBus';
import axios from 'axios';
import AgingBalance from '@/components/_AgingBalance/index.vue';

import JsonEditor from '@/components/JsonEditor/index.vue';
import MainContacts from '@/components/_MainContacts/index.vue';
import { defineComponent } from 'vue';
import { GqlPaymentPlan_PaymentPlansDocument, GqlPaymentPlan_PaymentPlansQueryVariables, Risolto_Document_Attachment_Type_Enum, ViewsRecipient_Recipient } from '@/generated/graphql';
import ViewsRecipient_customTags from './custom-tags.graphql';
import ViewsRecipient_userInterfaceDetails from './user-interface-details.graphql';
import AttachmentHelper from '@/helpers/attachment';
import TranslationHelper from '@/helpers/translation';
import Pagination from '@/components/Pagination/index.vue';
import { recipientAddTag, recipientRemoveTag, recipientEndCollection, recipientUploadAttachment, recipientDeleteAttachment } from '@/api/recipient';
import Logging from '@/logging';
import CustomFieldLabel from '@/components/_CustomFields/CustomFieldLabel.vue';
import CustomFieldValue from '@/components/_CustomFields/CustomFieldValue.vue';
import CustomFieldsList from '@/components/_CustomFields/CustomFieldsList.vue';
import { actionAddCreditNoteCopyEmail, actionAddCreditNoteCopyMail } from '@/api/action';
import { S3_Attachment } from '@/schema/attachment';
import AttachmentsDialog from '@/components/_dialogs/AttachmentsDialog.vue';
import RecipientActionTable from '@/components/_ActionTable/RecipientActionTable.vue';
import { format } from 'date-fns';
import { nl, fr, enGB } from 'date-fns/locale';
import { hasLicenseAndPermission } from '@/helpers/permission-helper';

const locales = { nl, fr, enGB };

const RECIPIENT_ATTACHMENTS = gql`
query ViewsRecipientRecipientDetail_recipientAttachments ($recipient: uuid!) {
	recipientAttachments: risolto_recipient_attachment(
		where: {
			recipient: { _eq: $recipient }
		}
	) {
		metadata
	}
}
`;

export default defineComponent({
	apollo: {
		customTags: {
			query: ViewsRecipient_customTags,
			variables() {
				return {
					participant: this.selectedParticipantStore
				};
			}
		},
		userInterfaceDetails: {
			query: ViewsRecipient_userInterfaceDetails,
			variables() {
				return {
					participant: this.selectedParticipantStore
				};
			},
			update: data => data.userInterfaceDetails[0]
		},
		recipientAttachments: {
			query: RECIPIENT_ATTACHMENTS,
			variables() {
				return {
					recipient: this.recipientRef
				};
			},
			update: data => data.recipientAttachments.map((attachment) => {
				return {
					...attachment.metadata
				};
			}),
			skip() {
				return !this.recipientRef;
			}
		}
	},
	components: {
		RiskScore,
		AvgPayment,
		ActionsNotes,
		Contacts,
		Pagination,
		AgingBalance,
		JsonEditor,
		MainContacts,
		CustomFieldLabel,
		CustomFieldValue,
		CustomFieldsList,
		AttachmentsDialog,
		DocumentTable,
		RecipientActionTable
	},
	props: {
		recipientRef: { type: String, required: true }
	},
	data() {
		return {
			activeTab: 'DETAIL',
			invoicesPage: 1,
			invoicesLimit: 25,
			invoicesSort: { open_amount: 'desc_nulls_last', issue_date: 'desc_nulls_last' },
			creditsLoading: false,
			creditnotes: undefined,
			creditnotesPageCount: 1,
			creditNotestotal: undefined,
			creditNotePage: 1,
			creditnoteLimit: 25,
			debitNotePage: 1,
			debitnoteLimit: 25,
			debitnotes: undefined,
			debitnotesPageCount: 1,
			debitnotesTotal: undefined,
			debitnotesLoading: false,
			paymentDocumentsLoading: false,
			paymentDocuments: undefined,
			paymentDocumentsPageCount: 1,
			paymentDocumentsPage: 1,
			paymentDocumentsCount: undefined,
			paymentDocumentsPageCountLimit: 25,
			paymentDocumentsTotal: undefined,
			paymentPlans: [],
			latestActionBeforePayment: undefined,
			nextDraftActions: undefined,
			totalNextDraftActions: 0,
			currentRecipientIndex: undefined,
			totalNotes: 0,
			currentNotes: undefined,
			deliveryEvents: {},
			availableEndpoints: [],
			recipient: undefined,
			availableActions: [],
			invoices: undefined,
			contacts: undefined,
			latestActions: undefined,
			latestAction: undefined,
			totalActions: 0,
			totalInvoices: 0,
			totalContacts: 0,
			actionDialogVisible: false,
			page: 1,
			queryVars: {
				status: ['OPEN', 'OVERDUE', 'CLOSED'],
				recipients: this.recipientRef ? [this.recipientRef] : [],
				limit: 25,
				offset: 0,
				today: new Date().toISOString()
			},
			multipleSelection: [],
			percentage: 10,
			colors: [
				{ color: '#3DE600', percentage: 0 },
				{ color: '#F0E800', percentage: 20 },
				{ color: '#CFEB00', percentage: 40 },
				{ color: '#FFA800', percentage: 60 },
				{ color: '#F05B00', percentage: 80 },
				{ color: '#FF252B', percentage: 90 }
			],
			currentInvoice: undefined,
			queryVarsLatestActions: {
				limit: 3,
				offset: 0,
				status: ['DONE', 'CANCELED'],
				orderBy: { executed_at: 'desc_nulls_last' },
				recipientRef: this.recipientRef,
				participant: undefined,
				invoice: undefined
			},
			queryVarsNotes: {
				limit: 3,
				offset: 0,
				recipientRef: this.recipientRef,
				participant: this.$store.getters.selectedParticipantStore
			},
			queryVarsRecipients: {
				limit: 25,
				offset: 0,
				orderBy: undefined,
				partRef: this.$store.getters.selectedParticipantStore
			},
			nextActionsDialogVisible: false,
			rightPanelLayoutVariables: {
				mainPanelWidth: 17,
				rightPanelWidth: 7
			},
			showCustomFields: false,
			showTagSelect: false,
			selectedCreditNotes: [],
			sendCreditNoteCopyMailloading: false,
			sendCreditNoteCopyEmailloading: false,
			attachmentsDialogVisible: false,
			showActionTable: false,
			userInterfaceDetails: null,
			tags: []
		};
	},
	computed: {
		...mapGetters(['env', 'beta', 'selectedParticipantStore', 'recipientsDetailRightPanelCollapsed', 'loggedInUser']),
		hasPaymentPlan() {
			if (!this.paymentPlans || this.paymentPlans.length === 0) {
				return false;
			}
			const openPaymentPlans = this.paymentPlans.filter((paymentPlan) => {
				return paymentPlan.is_open;
			});

			return openPaymentPlans.length > 0;
		},
		showTriggerDunning() {
			return true;
		},
		hasMessagesPermission() {
			const licences = this.$store.state.risolto.licences[this.selectedParticipantStore];
			const permissions = this.$store.state.risolto.permissions[this.selectedParticipantStore];

			return hasLicenseAndPermission(
				licences,
				permissions,
				'MAILBOX'
			);
		},
		isRecipientReady() {
			return this.recipient && this.userInterfaceDetails;
		}
	},
	watch: {
		'$route.name': {
			immediate: true,
			handler(newName) {
				if (newName === 'recipient-detail') {
					this.activeTab = 'DETAIL';
				} else if (newName === 'recipient-messages') {
					this.activeTab = 'MESSAGES';
				} else if (newName === 'recipient-archive') {
					this.activeTab = 'ARCHIVE';
				}
			}
		},
		selectedParticipantStore() {
			this.getRecipient();
			this.queryVarsLatestActions.participant = this.selectedParticipantStore;
			this.queryVarsLatestActions.recipientRef = this.$route.params.id;
			this.queryVarsNotes.participant = this.selectedParticipantStore;
			this.queryVarsNotes.recipientRef = this.$route.params.id;

			this.queryVarsRecipients = {
				limit: 25,
				offset: 0,
				partRef: this.selectedParticipantStore
			};

			this.getPaymentTriggerData();
		},
		// availableParticipants() {
		// 	this.checkParticipants();
		// },
		isRecipientReady: {
			handler(isReady) {
				if (isReady) {
					this.initializeRecipientData();
				}
			},
			immediate: true
		},
		recipientsDetailRightPanelCollapsed() {
			this.evaluateLayout();
		},
		'$store.state.apollo.risolto_message': function() {
			this.getRecipient();
		}
	},
	created() {
		// this.checkParticipants();
		this.getPaymentTriggerData();
		this.getRecipient();

		this.$store.commit('risolto/SET_NEW_NOTE_TYPE', 'recipient');
		this.$store.dispatch('risolto/setSelectedInvoices', []);

		EventBus.$on('fetchActions_recipient', data => {
			this.getNextActions();
		});

		if (this.selectedParticipantStore) {
			this.queryVarsLatestActions.participant = this.selectedParticipantStore;
			this.queryVarsNotes.participant = this.selectedParticipantStore;
			this.queryVarsLatestActions.recipientRef = this.$route.params.id;
			this.queryVarsNotes.recipientRef = this.$route.params.id;
		}

		this.evaluateLayout();
	},
	destroyed() {
		this.$store.commit('risolto/SET_SELECTED_RECIPIENT', undefined);
		this.$store.commit('risolto/SET_SHOW_ACTION_TABLE_FILTERS', false);
	},
	methods: {
		initializeRecipientData() {
			this.getNextActions();
			if (!this.userInterfaceDetails.use_accounting_documents_table) {
				this.invoicesPage = 1;
				this.invoicesLimit = 25;
				this.getCreditNotes(this.creditNotePage, this.creditnoteLimit);
				this.getDebitNotes(this.debitNotePage, this.debitnoteLimit);
				this.getPaymentDocuments(this.paymentDocumentsPage, this.paymentDocumentsPageCountLimit);
			}
			this.getPaymentPlans();
			this.getPaymentTriggerData();
			EventBus.$emit('refetchActionsNotes', {});
		},
		handleTabClick(tab) {
			const { id } = this.$route.params;

			if (tab.name === 'DETAIL') {
				this.$router.push({ name: 'recipient-detail', params: { id } });
			} else if (tab.name === 'MESSAGES') {
				this.$router.push({ name: 'recipient-messages', params: { id } });
			} else if (tab.name === 'ARCHIVE') {
				this.$router.push({ name: 'recipient-archive', params: { id } });
			}
		},
		handleShowPaymentPlanDetail(paymentPlan) {
			this.$router.push({
				name: 'edit-payment-plan',
				params: {
					id: paymentPlan,
					recipient: this.recipient.reference
				}
			});
		},
		isPdf(attachment) {
			return AttachmentHelper.isPdf(attachment);
		},
		isXml(attachment) {
			return AttachmentHelper.isXml(attachment);
		},
		evaluateLayout() {
			if (this.recipientsDetailRightPanelCollapsed) {
				this.rightPanelLayoutVariables.mainPanelWidth = 24;
				this.rightPanelLayoutVariables.rightPanelWidth = 0;
			} else {
				this.rightPanelLayoutVariables.mainPanelWidth = 17;
				this.rightPanelLayoutVariables.rightPanelWidth = 7;
			}
		},
		toggleRightPanel(value) {
			this.$store.commit('recipients/SET_DETAIL_RIGHT_PANEL_COLLAPSED', value);
		},
		onShowAllNextActions() {
			this.showActionTable = true;
		},
		async getPaymentPlans() {
			const variables: GqlPaymentPlan_PaymentPlansQueryVariables = {
				participant: this.selectedParticipantStore,
				recipient: this.recipient.reference
			};
			const result = await this.$apollo.query({
				query: GqlPaymentPlan_PaymentPlansDocument,
				variables: variables
			});

			this.paymentPlans = result.data.paymentPlans;
		},
		async getPaymentDocuments(page = 1, limit = 25) {
			this.paymentDocumentsLoading = true;
			try {
				let queryVars = {
					participant: this.selectedParticipantStore,
					recipient: this.recipient.reference,
					limit: limit,
					offset: Math.ceil((page - 1) * limit)
				};
				const result = await this.$apollo.query({
					query: PAYMENT_DOCUMENT,
					variables: queryVars
				});

				if (result.data.payment_documents) {
					this.paymentDocuments = result.data.payment_documents;
					this.paymentDocumentsTotal = result.data.total.aggregate.count;
					this.paymentDocumentsPageCount = Math.ceil(
						result.data.total.aggregate.count / limit
					);
					console.log('this.paymentDocumentsPageCount', this.paymentDocumentsPageCount);
				} else {
					Logging.log('result get getPaymentDocuments: ', result);
				}
			} catch (e) {
				Logging.error('error in getPaymentDocuments: ', e);
			} finally {
				this.paymentDocumentsLoading = false;
			}
		},
		async getCreditNotes(page = 1, limit = 25) {
			console.log('get credit notes - page ', page);
			this.creditsLoading = true;
			try {
				let queryVars = {
					participant: this.selectedParticipantStore,
					recipient: this.recipient.reference,
					offset: (page - 1) * limit,
					limit: limit
				};
				console.log('fetching queryVars', queryVars);
				const result = await this.$apollo.query({
					query: GET_CREDIT_NOTES,
					variables: queryVars
				});
				if (result.data.risolto_credit_note) {
					this.creditnotes = result.data.risolto_credit_note;
					this.creditNotestotal = result.data.total.aggregate.count;
					this.creditnotesPageCount = Math.ceil(result.data.total.aggregate.count / limit);
					console.log('this.creditnotesPageCount', this.creditnotesPageCount);
				} else {
					Logging.log('result get creditnotes: ', result);
				}
			} catch (e) {
				Logging.error('error in creditnotes: ', e);
			}
			this.creditsLoading = false;
		},
		async onClickDocIcon(val) {
			attachmentDownload(this.selectedParticipantStore, val);
		},
		async getDebitNotes(page = 1, limit = 25) {
			this.debitnotesLoading = true;
			try {
				let queryVars = {
					participant: this.selectedParticipantStore,
					recipient: this.recipient.reference,
					offset: (page - 1) * limit,
					limit: limit
				};
				const result = await this.$apollo.query({
					query: GET_DEBIT_NOTES,
					variables: queryVars
				});

				if (result.data.risolto_debit_note) {
					this.debitnotes = result.data.risolto_debit_note;
					this.debitnotesTotal = result.data.total.aggregate.count;
					this.debitnotesPageCount = Math.ceil(result.data.total.aggregate.count / limit);
				} else {
					Logging.log('result get debitnotes: ', result);
				}
			} catch (e) {
				Logging.error('error in debitnotes: ', e);
			}
			this.debitnotesLoading = false;
		},
		async getNextActions() {
			if (this.selectedParticipantStore) {
				const nextDraftActionVars = {
					participant: this.selectedParticipantStore,
					recipient: this.$route.params.id,
					statuses: ['OPEN', 'DRAFT'],
					limit: 3,
					searchTerm: '%%',
					invoices: null,
					orderBy: {'start_time': 'asc_nulls_last'}
				};

				const response = await this.$apollo.query({
					query: GET_NEXT_ACTIONS_V2,
					variables: nextDraftActionVars
				});

				if (response.data.risolto_action) {
					this.nextDraftActions = response.data.risolto_action;
					this.totalNextDraftActions = response.data.total.aggregate.count;
				} else {
					Logging.log('Error in GET_NEXT_ACTIONS: ', response);
				}
			}
		},
		async onTriggerDunning() {
			if (this.selectedParticipantStore) {
				try {
					let payload = {
						participant: this.selectedParticipantStore,
						legal_entity: this.recipient.legal_entity,
						recipient: this.recipient.reference
					};

					// eslint-disable-next-line
					const result = await axios.post(`https://${process.env.VUE_APP_API_ENDPOINT}/dunning/v1/start-recipient-dunning`, payload, {
						headers: { Authorization: `Bearer ${localStorage.getItem('rslt_id_token')}` }
					});

					this.$notify({
						title: this.$t('dunningTriggered'),
						type: 'success'
					});

					this.getRecipient();
				} catch (e) {
					Logging.error(e);
					this.$notify({
						title: this.$t('warning'),
						message: this.$t('somethingWentWrong'),
						type: 'warning'
					});
				}
			}
		},
		getRecipient() {
			if (this.selectedParticipantStore !== null) {
				// GET THE RECIPIENT

				const vars = {
					recipient: this.$route.params.id,
					participant: this.selectedParticipantStore
				};

				this.$apollo
					.query({
						query: ViewsRecipient_Recipient,
						variables: vars
					})
					.then(result => {
						Logging.log('RecipientDetail.getRecipient: data - ', result.data.risolto_recipient[0]);
						this.recipient = result.data.risolto_recipient[0];
						Logging.log('RecipientDetail.getRecipient - recipient: ', result.data.risolto_recipient[0]);
						this.$store.commit('risolto/SET_SELECTED_RECIPIENT', this.recipient);

						if (this.selectedParticipantStore) {
							this.queryVarsRecipients = {
								limit: 25,
								offset: 0,
								partRef: this.selectedParticipantStore
							};
						}

						this.$apollo
							.query({
								query: GET_CONTACTS,
								variables: {
									participant: this.recipient.participant,
									// participant: this.selectedParticipantStore,
									recipient: this.recipient.reference
								}
							})
							.then(result => {
								Logging.log('RecipientDetail.GET_CONTACT - contact: ', result.data);
								if (result.data) {
									this.contacts = result.data.contacts;

									for (let contact of result.data.contacts) {
										let availableEndpoints = contact.channel_endpoints.filter(el => {
											if (el.channel === 'PHONE' || el.channel === 'EMAIL' || el.channel === 'MAIL') { // TODO: PEPPOL
												if (el.channel === 'PHONE') el.icon = 'phone-solid';
												if (el.channel === 'EMAIL') el.icon = 'at-solid';
												if (el.channel === 'MAIL') el.icon = 'envelope-solid';
												if (el.channel === 'PEPPOL') el.icon = 'envelope-solid'; // TODO: PEPPOL icon (e.g. electronic-receipt)
												return el;
											}
										});
										contact.channel_endpoints = availableEndpoints;
									}
								}
							})
							.catch(e => {
								Logging.error(e);
							});
					})
					.catch(e => {
						Logging.error('Error in recp-detail/created/GET_RECIPIENT: ', e);
					});
			} else {
				//
			}
		},
		customFormatter(value) {
			return format(new Date(value), 'eeee, d MMMM yyyy - HH:mm', { locale: locales[this.$i18n.locale] ?? enGB });
		},
		async getPaymentTriggerData() {
			try {
				const response = await this.$apollo.query({
					query: FIND_INVOICE_PAYMENT_TRIGGER,
					variables: {
						recipient: this.$route.params.id
					}
				});

				if (
					response.data &&
					response.data.risolto_recipient &&
					response.data.risolto_recipient[0] &&
					response.data.risolto_recipient[0].invoice_documents &&
					response.data.risolto_recipient[0].invoice_documents[0]
				) {
					this.latestActionBeforePayment = response.data.risolto_recipient[0].invoice_documents[0].action_invoices[0].action_by_reference;
					// console.log('this.latestActionBeforePayment: ', this.latestActionBeforePayment);
				} else {
					// console.log('There is no latest action before payment.');
				}
			} catch (e) {
				Logging.error('Error in getPaymentTriggerData: ', e);
			}
		},
		checkParticipants() {
			Logging.log('this.availableParticipants: ', this.availableParticipants);
			try {
				if (this.availableParticipants.length >= 1) {
					const routeParticipant = this.$route.params.participant;

					if (routeParticipant !== this.selectedParticipantStore) {
						const i = this.availableParticipants.findIndex(el => {
							return el.reference === routeParticipant;
						});

						if (i === -1) {
							this.$notify({
								title: this.$t('warning'),
								message: this.$t('notAllowed'),
								type: 'error'
							});
							this.$router.push({
								name: 'dashboard'
							});
						} else {
							EventBus.$emit('setParticipant', routeParticipant);
						}
					}
				}
			} catch (e) {
				Logging.error('Smth went wrong in recpDetail/checkParticipants()', e);
			}
		},
		handleReactivate(reference) {
			this.$apollo
				.mutate({
					mutation: REACTIVATE_ENDPOINT,
					variables: {
						participant: this.selectedParticipantStore,
						reference: reference
					}
				})
				.then(result => {
					// console.log(result);
					this.$apollo.queries.getRecipient.refetch();
					this.$notify({
						title: this.$t('success'),
						message: this.$t('endpointActivated'),
						type: 'success'
					});
				})
				.catch(e => {
					Logging.error('REACTIVATE_ENDPOINT: ', e);
				});
		},
		handleCreditNotesSelectionChange(val) {
			this.selectedCreditNotes = val;
		},
		async handleSendCreditNoteCopyMail() {
			if (this.sendCreditNoteCopyMailloading) {
				return;
			}
			this.sendCreditNoteCopyMailloading = true;

			const recipient = this.recipient;
			const creditNotes = this.selectedCreditNotes;

			actionAddCreditNoteCopyMail(
				recipient.reference,
				creditNotes.map((creditNote) => {
					return creditNote.reference;
				})
			)
				.then((result) => {
					var action = result.data.action;

					this.$store.commit('actions/UPSERT_ACTION', action, { root: true });
					this.$store.commit('actions/SET_SELECTED_ACTION_REF', action.reference, { root: true });
					this.$store.commit('risolto/SET_SELECTED_RECIPIENT', action.recipient_by_reference, { root: true });
					this.$store.commit('risolto/SET_COMPONENT_TYPE_STORE', action.channel, { root: true });
					this.$store.commit('risolto/SET_ACTION_DETAIL_DIALOG_VISIBLE', true, { root: true });

					this.sendCreditNoteCopyMailloading = false;
				})
				.catch((e) => {
					this.sendCreditNoteCopyMailloading = false;
				});
		},
		async handleSendCreditNoteCopyEmail() {
			if (this.sendCreditNoteCopyEmailloading) {
				return;
			}
			this.sendCreditNoteCopyEmailloading = true;

			if (this.selectedCreditNotes.length === 1) {
				actionAddCreditNoteCopyEmail(this.selectedParticipantStore, this.recipient.legal_entity, this.recipient.reference, this.selectedCreditNotes[0].reference)
					.then((result) => {
						var action = result.data.action;

						this.$store.commit('actions/UPSERT_ACTION', action);
						this.$store.commit('actions/SET_SELECTED_ACTION_REF', action.reference);
						this.$store.commit('risolto/SET_SELECTED_RECIPIENT', action.recipient_by_reference);
						this.$store.commit('risolto/SET_COMPONENT_TYPE_STORE', action.channel);
						this.$store.commit('risolto/SET_ACTION_DETAIL_DIALOG_VISIBLE', true);
					})
					.finally(() => {
						this.sendCreditNoteCopyEmailloading = false;
					});
			}
		},
		translateTag(tag) {
			return TranslationHelper.tag(this, tag);
		},
		handleAddTagClick() {
			this.showTagSelect = true;
			this.$nextTick(_ => {
				this.$refs.selectTag.focus();
			});
		},
		async handleAddTagAdd(value) {
			await recipientAddTag(
				this.selectedParticipantStore,
				this.recipient.legal_entity,
				this.recipient.reference,
				value
			);
			this.getRecipient();

			this.showTagSelect = false;
		},
		/**
		 * @param value tag reference
		 * @param name tag name
		 */
		async handleTagRemove(value, name) {
			if (name === 'COLLECTION') {
				await this.$confirm(this.$i18n.t('RecipientDetail.confirm_end_collection_message'), 'Warning', {
					confirmButtonText: this.$i18n.t('RecipientDetail.confirm_end_collection_confirm'),
					cancelButtonText: this.$i18n.t('RecipientDetail.confirm_end_collection_cancel'),
					type: 'warning'
				}).then(async () => {
					this.$message({
						type: 'success',
						message: this.$i18n.t('RecipientDetail.confirm_end_collection_succeeded')
					});
					try {
						await recipientEndCollection(
							this.selectedParticipantStore,
							this.recipient.legal_entity,
							this.recipient.reference,
							this.loggedInUser.username,
							this.loggedInUser.reference
						);
					} catch (e) {
						Logging.error(e);
						this.$message({
							type: 'error',
							message: this.$i18n.t('RecipientDetail.confirm_end_collection_failure')
						});
					}
				}).catch(() => {
					this.$message({
						type: 'info',
						message: this.$i18n.t('RecipientDetail.confirm_end_collection_canceled')
					});
				});
			} else {
				await recipientRemoveTag(
					this.selectedParticipantStore,
					this.recipient.legal_entity,
					this.recipient.reference,
					value
				);
			}
			this.getRecipient();
		},
		handleAttachments() {
			this.attachmentsDialogVisible = true;
		},
		async handleAttachmentUpload(attachment: S3_Attachment) {
			try {
				await recipientUploadAttachment(
					this.selectedParticipantStore,
					this.recipient.legal_entity,
					this.recipient.reference,
					Risolto_Document_Attachment_Type_Enum.Pdf,
					attachment.name,
					attachment
				);

				this.recipientAttachments = [...this.recipientAttachments, attachment];
			} catch (e) {
				this.$notify({
					title: this.$t('invoice-disputes.error') as string,
					message: this.$t('invoice-disputes.attachment-can-not-be-uploaded') as string,
					type: 'error'
				});
				return;
			}
		},
		async handleAttachmentRemove(attachment: S3_Attachment) {
			try {
				await recipientDeleteAttachment(attachment.key);
				this.recipientAttachments = this.recipientAttachments.filter((item) => {
					return item.key !== attachment.key;
				});
			} catch (e) {
				this.$notify({
					title: this.$t('invoice-disputes.error') as string,
					message: this.$t('invoice-disputes.attachment-can-not-be-removed') as string,
					type: 'error'
				});
				return;
			}
		}
	}
});
